import { faYoutube } from "@fortawesome/free-brands-svg-icons";
import { faAddressCard, faChevronRight, faDharmachakra, faEarthEurope, faFile, faHome, faImages, faMessage, faNewspaper, faXmark, faXmarkCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { getNbMessNoReadAdmin } from "../actions/contact";
import { connect } from "react-redux";
import { tempAlWait } from "../helpers";

class AdminHeader extends React.Component {
    state = {
        nbMess: 0,
        alert: {
            active: false,
            type: '',
            title: '',
            desc: ''
        }
    }

    componentDidMount() {
        this.props.getNbMessNoReadAdmin();
        this.setState({
            alert: tempAlWait()
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.alert != this.state.alert) {
            this.props.changeAlert(this.state.alert);
        }

        if (prevProps.redNbNoReadAdmin != this.props.redNbNoReadAdmin) {
            this.setState({
                alert: this.props.redNbNoReadAdmin.alert,
                nbMess: this.props.redNbNoReadAdmin.datas
            })
        }
    }

    render() {
        return <header className={`adminHdr ${this.props.active && "adminHdr--active"}`}>
            {/** Bouton pour fermer **/}
            <button
                title="Fermer le menu"
                aria-label="Fermer le menu"
                className="adminHdr__btnClose"
                onClick={() => this.props.handleClose(false)}
            >
                <FontAwesomeIcon icon={faXmark} />
            </button>

            {/** Bouton pour agrandir **/}
            <button
                title={this.props.active ? "Réduire le menu" : "Déplier le menu"}
                aria-label={this.props.active ? "Réduire le menu" : "Déplier le menu"}
                className={`adminHdr__btnReduire ${this.props.active && "adminHdr__btnReduire--active"}`}
                onClick={() => this.props.handleClose(!this.props.active)}
            >
                <FontAwesomeIcon icon={faChevronRight} />
            </button>

            {/** Liste de navigation **/}
            <nav className="adminHdr__nav">
                {/** Accueil **/}
                <a
                    title="Page d'accueil"
                    aria-label="Page d'accueil"
                    className="adminHdr__link"
                    href={`https://${this.props.idtt.slug}.fr`}
                >
                    <div className="adminHdr__ico">
                        <FontAwesomeIcon icon={faHome} />
                    </div>
                    <span className="adminHdr__linktxt">Page d'accueil</span>
                </a>
                {/** Actualités **/}
                <Link
                    title="Actualités"
                    aria-label="Actualités"
                    className="adminHdr__link"
                    to="/admin/actus"
                >
                    <div className="adminHdr__ico">
                        <FontAwesomeIcon icon={faYoutube} />
                    </div>
                    <span className="adminHdr__linktxt">Actualités</span>
                </Link>
                {/** Galerie **/}
                <Link
                    title="Galerie"
                    aria-label="Galerie"
                    className="adminHdr__link"
                    to="/admin/galerie"
                >
                    <div className="adminHdr__ico">
                        <FontAwesomeIcon icon={faImages} />
                    </div>
                    <span className="adminHdr__linktxt">Galerie</span>
                </Link>
                {/** Contact **/}
                <Link
                    title="Contact"
                    aria-label="Contact"
                    className="adminHdr__link"
                    to="/admin/tchat"
                >
                    <div className="adminHdr__ico">
                        <FontAwesomeIcon icon={faMessage} />
                        {
                            this.state.nbMess != 0 &&
                            this.state.nbMess != null &&
                            <span className="adminHdr__badge">{this.state.nbMess}</span>
                        }
                    </div>
                    <span className="adminHdr__linktxt">Contact</span>
                </Link>
                {/** Newsletter **/}
                <Link
                    title="Newsletter"
                    aria-label="Newsletter"
                    className="adminHdr__link"
                    to="/admin/newsletter"
                >
                    <div className="adminHdr__ico">
                        <FontAwesomeIcon icon={faNewspaper} />
                    </div>
                    <span className="adminHdr__linktxt">Newsletter</span>
                </Link>
                {/** Parcs - Temps d'attente **/}
                <Link
                    title="Parcs (temps d'attente)"
                    aria-label="Parcs (temps d'attente)"
                    className="adminHdr__link"
                    to="/admin/parcs"
                >
                    <div className="adminHdr__ico">
                        <FontAwesomeIcon icon={faEarthEurope} />
                    </div>
                    <span className="adminHdr__linktxt">Parcs</span>
                </Link>
                {/** Attractions - Temps d'attente **/}
                <Link
                    title="Attractions (temps d'attente)"
                    aria-label="Attractions (temps d'attente)"
                    className="adminHdr__link"
                    to="/admin/attractions"
                >
                    <div className="adminHdr__ico">
                        <FontAwesomeIcon icon={faDharmachakra} />
                    </div>
                    <span className="adminHdr__linktxt">Attractions</span>
                </Link>
                {/** Identité **/}
                <Link
                    title="Identité"
                    aria-label="Identité"
                    className="adminHdr__link"
                    to="/admin/identite"
                >
                    <div className="adminHdr__ico">
                        <FontAwesomeIcon icon={faAddressCard} />
                    </div>
                    <span className="adminHdr__linktxt">Identité</span>
                </Link>
                {/** Fichiers **/}
                {
                    localStorage.getItem('userRole') == ["ROLE_SUPER_ADMIN"] &&
                    <Link
                        title="Fichiers"
                        aria-label="Fichiers"
                        className="adminHdr__link"
                        to="/admin/projects"
                    >
                        <div className="adminHdr__ico">
                            <FontAwesomeIcon icon={faFile} />
                        </div>
                        <span className="adminHdr__linktxt">Projets</span>
                    </Link>
                }
            </nav>
        </header>
    }
}

const mapStateToProps = state => {
    return {
        redNbNoReadAdmin: state.redNbNoReadAdmin
    }
}

const mapDispatchToProps = {
    getNbMessNoReadAdmin
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminHeader);